import { styled } from 'styled-components';

interface StylePrefixWrapProps {
  index: number;
  $source?: string;
}

interface StyleDropdownContentProps {
  top: number;
}
export const StyleDropdownContent = styled.div<StyleDropdownContentProps>`
  position: absolute;
  top: ${({ top }) => top || 46}px;
  left: 0%;
  box-shadow: var(--pcm-modal-box-shadow);
  background: var(--pcm-body-background);
  border-radius: var(--pcm-rounded-lg);
  z-index: 10;
  overflow: hidden;
`;

export const StyleDropdownWrapper = styled.div`
  flex-shrink: 0;
  padding: 8px;
  overflow-y: auto;
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyleChainItem = styled.div<{ selected: boolean }>`
  height: 36px;
  display: flex;
  justify-content: flex-start;
  padding-left: 8px;
  padding-right: 30px;
  position: relative;
  border-radius: var(--pcm-rounded-sm);
  align-items: center;
  z-index: 2;
  cursor: pointer;
  ${({ selected }) =>
    selected &&
    `
    .chain-name {
      color: #a257fa;
    }
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 34px;
      left: 0;
      top: 0px;
      background-color: var(--pcm-accent-color);
      opacity: 0.2;
      border-radius: var(--pcm-rounded-sm);
    }
  `}
`;

export const StyleCheckIcon = styled.div`
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-60%);
`;

export const StyleChainName = styled.div`
  font-size: 12px;
`;

export const StyleHoverBg = styled.div<StylePrefixWrapProps>`
  pointer-events: none;
  position: absolute;
  top: ${({ index, $source }) => ($source === 'countryList' ? index * 46 + 8 : index * 36 + 9)}px;
  left: 8px;
  width: calc(100% - 16px);
  height: ${({ $source }) => ($source === 'countryList' ? '46px' : '34px')};
  background-color: var(--pcm-accent-color);
  opacity: 0.1;
  border-radius: var(--pcm-rounded-sm);
  z-index: 11;
  display: ${({ index }) => (index === -1 ? 'none' : 'block')};
  transition: top 0.1s;
`;
